<template>
  <div class="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
    <div class="px-4 py-3 bg-gradient-to-r from-green-50 to-teal-50 border-b border-slate-100">
      <div class="flex items-center gap-2">
        <Layout class="w-4 h-4 text-green-600" />
        <span class="font-bold text-sm text-slate-800">תוכן האתר שלך</span>
      </div>
    </div>
    <div class="p-4 space-y-4">
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-500">כותרת משנה</label>
        <InputText
          :modelValue="siteContent.subTitle"
          @update:modelValue="$emit('update-subtitle', $event)"
          class="w-full !bg-slate-50 !border !border-slate-200 !text-slate-800 !rounded-xl !py-2.5 !text-sm focus:!border-pink-500"
          placeholder="כותרת משנה קצרה..."
        />
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-500">אודות העסק</label>
        <Textarea
          :modelValue="siteContent.about"
          @update:modelValue="$emit('update-about', $event)"
          class="w-full !bg-slate-50 !border !border-slate-200 !text-slate-800 !rounded-xl !py-2.5 !text-sm focus:!border-pink-500"
          rows="3"
          autoResize
          placeholder="ספרו על העסק שלכם..."
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import { Layout } from 'lucide-vue-next';

defineProps<{
  siteContent: {
    about: string;
    subTitle: string;
  };
}>();

defineEmits<{
  'update-subtitle': [value: string];
  'update-about': [value: string];
}>();
</script>
